var MarkType;
(function (MarkType) {
    MarkType["BOLD"] = "bold";
    MarkType["ITALIC"] = "italic";
    MarkType["UNDERLINE"] = "underline";
    MarkType["CLASSNAME_OR_ID"] = "classnameOrId";
    MarkType["STRIKE_THROUGH"] = "strikethrough";
    MarkType["INLINE_CODE"] = "inlineCode";
    MarkType["SUBSCRIPT"] = "subscript";
    MarkType["SUPERSCRIPT"] = "superscript";
    MarkType["BREAK"] = "break";
})(MarkType || (MarkType = {}));
export default MarkType;
//# sourceMappingURL=mark-type.js.map